import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { POSTS } from "../data/posts";
import { ArrowUpRight, Clock } from "lucide-react";

export default function Resources() {
    return (
        <div data-testid="resources-page" className="bg-[#0A0A0E] text-zinc-100 min-h-screen">
            <Navbar />
            <main className="pt-28 pb-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl mb-14">
                    <span className="section-tag">Resources · Insights</span>
                    <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white mt-5 leading-[0.95] tracking-tighter">
                        Practical reads for AU importers &amp; exporters.
                    </h1>
                    <p className="text-zinc-400 mt-6 leading-relaxed text-lg">
                        Market updates, cost-control playbooks and pragmatic trade guides —
                        published by the team that builds WE DELVR LOGISTICS.
                    </p>
                </div>

                <div className="grid lg:grid-cols-3 gap-5">
                    {POSTS.map((p, i) => (
                        <Link
                            key={p.slug}
                            to={`/resources/${p.slug}`}
                            data-testid={`resource-card-${i}`}
                            className="card-glow rounded-2xl overflow-hidden group flex flex-col"
                        >
                            <div className="aspect-[16/10] overflow-hidden">
                                <img
                                    src={p.cover}
                                    alt={p.title}
                                    className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
                                />
                            </div>
                            <div className="p-6 flex flex-col flex-1">
                                <div className="flex items-center gap-3 text-[11px] font-mono-accent uppercase tracking-[0.18em] text-zinc-500 mb-3">
                                    <span className="text-cyan-300">{p.category}</span>
                                    <span>·</span>
                                    <span>{p.date}</span>
                                </div>
                                <h3 className="font-display text-xl text-white tracking-tight group-hover:text-cyan-300 transition-colors">
                                    {p.title}
                                </h3>
                                <p className="text-sm text-zinc-400 mt-3 leading-relaxed flex-1">
                                    {p.excerpt}
                                </p>
                                <div className="mt-5 pt-5 border-t border-white/5 flex items-center justify-between text-xs text-zinc-500">
                                    <span className="flex items-center gap-2">
                                        <Clock size={12} /> {p.readMinutes} min read
                                    </span>
                                    <ArrowUpRight size={16} className="text-cyan-300 opacity-70 group-hover:opacity-100" />
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </main>
            <Footer />
        </div>
    );
}
